// Main javascript entry point
'use strict';

import $ from 'jquery';
import retina from 'retinajs';

import Header from '../_modules/header/header';
import InitiativesGrid from '../_modules/initiatives-grid/initiatives-grid';
import ImagesCarousel from '../_modules/images-carousel/images-carousel';
import VideosCarousel from '../_modules/videos-carousel/videos-carousel';
import TalkersCarousel from '../_modules/talkers-carousel/talkers-carousel';
import NextInitiatives from '../_modules/next-initiatives/next-initiatives';
import InscriptionForm from '../_modules/inscription-form/inscription-form';
import HeroVideo from '../_modules/hero-video/hero-video';
import OnlineModule from '../_modules/online-modules/online-modules';
import Hero from '../_modules/hero/hero';

window.addEventListener('load', retina);

$(() => {
  new Header();
  new InitiativesGrid();
  new ImagesCarousel();
  new VideosCarousel();
  new TalkersCarousel();
  new NextInitiatives();
  new InscriptionForm();
  new HeroVideo();
  new OnlineModule();
  new Hero();

  $(document).on('click', 'a[href^="#"]',  function(event) {

    if ( $(this).attr('href').trim() === '#' ) {
      return;
    }

    event.preventDefault();

    $('html, body').animate({
      scrollTop: $($.attr(this, 'href')).offset().top
    }, 500);
  });

  // Preload images
  let preImage = new Image();
  preImage.sr = '//images/caret-right-grey.png';
});
